import { render, staticRenderFns } from "./page-task.vue?vue&type=template&id=03d23138&scoped=true"
import script from "./page-task.vue?vue&type=script&lang=js"
export * from "./page-task.vue?vue&type=script&lang=js"
import style0 from "./page-task.vue?vue&type=style&index=0&id=03d23138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d23138",
  null
  
)

export default component.exports